import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TextField, Button, Typography, Grid, Paper } from '@mui/material';
import FormContainer from 'containers/FormContainer';
import IntlMessages from 'lngProvider/IntlMessages';
import * as Yup from 'yup';
import { EmailValidation } from 'services/EnumConstants'
import { styled } from '@mui/material/styles';
import { spacing } from 'styles/Common';
import { getPaperStyleObject } from 'styles/Paper';

const StyledPaper = styled(Paper)((
    {
        theme
    }
    ) => {
        let paperStyle = getPaperStyleObject(theme);
    return {
            ...paperStyle.root,
            [theme.breakpoints.up('lg')]: {
                maxWidth: '750px',
                marginTop: spacing[32]
            },
            '& .MuiInputBase-input': {
                height: 30,
                padding: 4
            },
            '& a': {
                textDecoration: 'underline'
            }
    };
});

const ForgotPasswordWeb = (props) => {
    const emailRegex = EmailValidation.Production;

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .trim()
            .required(<IntlMessages id="forgotPassword.invalidEmail" />)
            .email(<IntlMessages id="forgotPassword.invalidEmail" />)
            .matches(emailRegex, true)
    });

    const location = useLocation();
    const { data, onSubmit, loginConfig } = props;

    return (
        <StyledPaper>
        <FormContainer
            initialValues={data}
            validationSchema={validationSchema}
            onSubmit={onSubmit}>

            {props => {
                const {
                    values,
                    errors,
                    touched,
                    isSubmitting,
                    handleChange
                } = props;

                return (
                    <Grid>
                        <Typography variant="h4"><IntlMessages id={loginConfig.forgotPasswordTitle} /></Typography>
                        <Typography variant="subtitle2"><IntlMessages id={loginConfig.forgotPasswordSubTitle} /></Typography>
                        <hr />
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <TextField
                                    label={<IntlMessages id="forgotPassword.email" />}
                                    value={values.email}
                                    onChange={handleChange}
                                    error={errors.email && touched.email}
                                    helperText={((errors.email && touched.email) && errors.email)}
                                    name="email"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    inputProps={{ maxLength: 256 }}
                                    fullWidth />
                            </Grid>
                            <Grid item xs={12}>
                                <Button color="primary"
                                    type="submit"
                                    variant="contained"
                                    disabled={isSubmitting ||
                                        !!errors.password ||
                                        !values.email ||
                                        values.email === '' ||
                                        !!errors.email} fullWidth>
                                    <IntlMessages id={loginConfig.forgotPasswordButtonText} />
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subtitle2"><IntlMessages id={loginConfig.backToLoginText} />&nbsp;<Link to={`/app/login${location.search}`}><IntlMessages id="forgotPassword.signIn" /></Link></Typography>
                            </Grid>
                        </Grid>

                    </Grid>
                );

            }}
        </FormContainer>
        </StyledPaper>
    );
}

export default ForgotPasswordWeb;
